'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = AuditLogRowDirective;

var _auditLogDetailsDialogTpl = require('./audit-log-details-dialog.tpl.html');

var _auditLogDetailsDialogTpl2 = _interopRequireDefault(_auditLogDetailsDialogTpl);

var _auditLogRowTpl = require('./audit-log-row.tpl.html');

var _auditLogRowTpl2 = _interopRequireDefault(_auditLogRowTpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

function AuditLogRowDirective($compile, $templateCache, types, $mdDialog, $document) {

    var linker = function linker(scope, element, attrs) {

        var template = $templateCache.get(_auditLogRowTpl2.default);
        element.html(template);

        scope.auditLog = attrs.auditLog;
        scope.auditLogMode = attrs.auditLogMode;
        scope.types = types;

        scope.showAuditLogDetails = function ($event) {
            var onShowingCallback = {
                onShowing: function onShowing() {}
            };
            $mdDialog.show({
                controller: 'AuditLogDetailsDialogController',
                controllerAs: 'vm',
                templateUrl: _auditLogDetailsDialogTpl2.default,
                locals: {
                    auditLog: scope.auditLog,
                    showingCallback: onShowingCallback
                },
                parent: angular.element($document[0].body),
                targetEvent: $event,
                fullscreen: true,
                skipHide: true,
                onShowing: function onShowing(scope, element) {
                    onShowingCallback.onShowing(scope, element);
                }
            });
        };

        $compile(element.contents())(scope);
    };

    return {
        restrict: "A",
        replace: false,
        link: linker,
        scope: false
    };
}


// WEBPACK FOOTER //
// ./src/app/audit/audit-log-row.directive.js